module.exports = __webpack_public_path__ + "img/sicrano.7cfd30f2.png";